@if(errorService.details().error;) {
<dashboard-error-part></dashboard-error-part>
}
@else if(auth.state().status !== 'signed-in') {
<common-internal-signed-out></common-internal-signed-out>
}
@else() {
<router-outlet></router-outlet>
}

@if(spinnerService.current()) {
<dashboard-spinner></dashboard-spinner>
}